<template>
  <div class="base-card">
    <img src="@/shared/assets/images/alert-icon.svg" alt="" />
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  @import './BaseCard';
</style>
